import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';

import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { WindowService } from 'src/shared/providers/window.service';
import { TranslationService } from 'src/tidy-ui-components/providers/translation.service';

import { Util } from 'src/shared/util/util';
import { DISPLAY_LANGUAGE_OPTIONS } from 'src/shared/constants/display-languages';

import { Client } from 'src/providers/client/client';

@Component({
    templateUrl: 'edit-language.html',
    standalone: false
})

export class EditLanguagePage implements OnInit {

  isRightSideContent: boolean;
  language: any;
  languageItems: any;
  form: UntypedFormGroup;
  loaded: boolean;

  
  boundSave = this.save.bind(this);

constructor(
    private client: Client,
    private fb: UntypedFormBuilder,
    private navCtrl: CustomNavController,
    private util: Util,
    private storage: TidyStorage,
    private rightSidePanelService: RightSidePanelService,
    private windowService: WindowService,
    private translationService: TranslationService
  ) {
    this.form = this.fb.group({
      language: [''],
    });
  }

  async ngOnInit() {
    this.loaded = false;
    const currentLanguage = localStorage.getItem('language');
    localStorage.setItem('didUpdateLanguage', 'false');
    localStorage.setItem('currentLanguage', currentLanguage);
    this.isRightSideContent = await this.storage.retrieve('dialog-right-side-open') || false;
    this.rightSidePanelService.setDialogPageTitle('Edit Display Language');
    this.languageItems = this.getLanguageItems();
    this.form.patchValue({
      language: currentLanguage || 'en'
    });
    this.loaded = true;
  }

  getLanguageItems() {
    return DISPLAY_LANGUAGE_OPTIONS;
  }

  async save() {
    await this.client.addMetadata({ key: 'language', value: this.form.value.language });
    localStorage.setItem('didUpdateLanguage', 'true');
    localStorage.setItem('didMakeMoreChange', 'true');
    localStorage.setItem('language', this.form.value.language);
    this.translationService.notifyLanguageChange();
    const successMessage = 'Language updated!';
    this.util.showSuccess(successMessage)
    if (this.windowService.isDesktopRes) {
      this.rightSidePanelService.closeRightSidePanel();
    } else {
      this.navCtrl.navigateForward('more');
    }
  }
  
  changeLanguage() {
    localStorage.setItem('language', this.form.value.language);
    this.translationService.notifyLanguageChange();
  }

}
